import {FieldType} from "../../manager/FieldType";
import {Avatar} from "./Avatar";
import {attributeGroups} from "./attributeGroups";
import {toolbox} from "./toolbox";
import {FieldTypeManager} from "../../manager/FieldTypeManager";

export const avatarFieldType: FieldType = {
  name: 'avatar',
  component: Avatar,
  attributeGroups: attributeGroups,
  toolbox,
};

FieldTypeManager.register(avatarFieldType.name, avatarFieldType);
